module.exports = __webpack_public_path__ + "static/media/crocmedia_dark_background.84383020.jpg";